<template>
  <div id="Dashboard">
    <Wrap class="lg">
      <h2>Dashboard</h2>
      <ImportForm :importData="importData" />
    </Wrap>
  </div>
</template>

<script>
import ImportForm from '../../components/forms/ImportForm'

export default {
  components: { ImportForm },
  data() {
    return {
      importData: {
        input: null,
        date: new Date(),
        orderNo: null,
        managerId: null,
        clientId: null,
        clientName: null,
        address1: null,
        address2: null,
        address3: null,
        isVerified: null,
        preview: null,
      },
    }
  },
}
</script>

<style lang="scss">
#Dashboard {
  display: flex;
  min-height: 100%;
  padding: 2rem 0;

  .Wrap {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
}
</style>

<i18n>
{
  "en": {
    "meta": {
      "title": {
        "complement": "Homepage",
        "inner": "AppMakers",
        "separator": "|"
      }
    },
    "title": "AppMakers",
    "button": "Documentation"
  }
}
</i18n>
